import React from 'react';
import { DispatchProp } from 'react-redux';
import { useSetResolved } from 'src/core/engine/router';
import { Home, HomeCarouselWrapper } from 'src/components/Home/Home';
import {
    loadBrandCarouselSection,
    loadCategoryListSection,
    loadInfoSection,
    loadReasonsSection,
    loadTrustedSection,
} from 'src/components/Home/deferredLoaders';
import { LazyHydrate } from 'src/components/AppShell/LazyHydrate';
import { DefaultMeta } from 'src/components/AppShell/Head';
import { FooterNewsletterConnected } from 'src/components/Footer/FooterNewsletter';

import { Container, Wrapper } from '../../components/Layout';
import '../../scss/_root-component.scss';

import { helmet } from './home';

type HomePageProps = {
    id: number;
    outdated: boolean;
    version: string | undefined;
} & DispatchProp<any>;

export const HomePage: React.FC<HomePageProps> = () => {
    useSetResolved();
    return (
        <div style={{ background: 'white' }}>
            <Home>
                <DefaultMeta data={helmet} withoutPrefix />
                <Wrapper variant="widget-wrapper">
                    <HomeCarouselWrapper />
                    <Container>
                        <LazyHydrate sectionId="home-category-list" load={loadCategoryListSection} />
                        <LazyHydrate sectionId="home-brand-carousel" load={loadBrandCarouselSection} />
                    </Container>
                </Wrapper>
                <Wrapper variant="page-inner" lighterBackground overflowHidden>
                    <Container>
                        <LazyHydrate sectionId="home-reasons" load={loadReasonsSection} />
                        <LazyHydrate sectionId="home-trusted" load={loadTrustedSection} />
                    </Container>
                </Wrapper>
                <Wrapper variant="page-inner" overflowHidden>
                    <Container>
                        <LazyHydrate sectionId="home-info" load={loadInfoSection} />
                    </Container>
                </Wrapper>
                <FooterNewsletterConnected />
            </Home>
        </div>
    );
};

export default HomePage;
